import { ColoursObj, Typography } from '@eventr/common-storybook'
import StarRateIcon from '@mui/icons-material/StarRate'
import { Box } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { useEphemeralStore } from '../../../state/useEphemeralStore'
import { openMobileMapsLink } from '../../../utils'

export const HotelDetailsHeader: FC = () => {
    const { hotelResp } = useEphemeralStore(
        useShallow((s) => ({
            hotelResp: s.hotelResp,
        }))
    )

    if (!hotelResp) {
        return null
    }

    return (
        <Box display={'grid'} gap={'8px'} maxWidth={'90vw'}>
            <Box display={'grid'} gridTemplateColumns={'1fr auto'}>
                <Typography variant="mobileH2" lineHeight={'20px'}>
                    {hotelResp.hotelInfo.name}
                </Typography>
                <Box
                    display={'grid'}
                    gridAutoFlow={'column'}
                    gap={'4px'}
                    sx={{
                        backgroundColor: ColoursObj.backgrounds.primary,
                        borderRadius: '24px',
                        width: 'max-content',
                        height: '24px',
                        padding: '0 8px',
                    }}
                >
                    <StarRateIcon
                        sx={{ width: '16px', height: '24px' }}
                        htmlColor={ColoursObj.core.primary}
                    />
                    <Typography
                        variant="bodyBold"
                        lineHeight={'24px'}
                        color={ColoursObj.core.primary}
                    >
                        {hotelResp.hotelInfo.starRating}
                    </Typography>
                </Box>
            </Box>
            <Box
                onClick={() => {
                    openMobileMapsLink(
                        `${hotelResp.hotelInfo.coordinates[0]},${hotelResp.hotelInfo.coordinates[1]}`
                    )
                }}
            >
                <Typography
                    variant="bodySubtext"
                    color={ColoursObj.font.secondary}
                >
                    {hotelResp.hotelInfo.address}
                </Typography>
            </Box>
            <Box>
                <Typography variant="bodySubtext">
                    {hotelResp.hotelInfo.numberOfReviews}{' '}
                    {i18n.t('booking.reviews')} (
                    {hotelResp.hotelInfo.reviewScore})
                </Typography>
            </Box>
        </Box>
    )
}
